// packages block
import { Box, Pagination } from '@mui/material';
import { ChangeEvent, FC } from 'react';
// others block
import { useAppContext } from '../../app/contexts/AppContext';
import { PaginationProps } from '../../app/interfaceTypes';
import { ActionType } from '../../app/reducer/AppContextReducer';

/**
 * It would render Dimensions listing page
 *
 * @returns JSX Element
 */
export const CustomPagination: FC<PaginationProps> = ({ loading }) => {
  const { totalPageCount, currentPage, dispatch } = useAppContext();

  const handleChange = (event: ChangeEvent<unknown> | null, newPage: number) => {
    console.log('event>>>>>>>>>>>', event); //Log because of npm run build
    dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: newPage });
  };

  return (
    <Box display="flex" justifyContent="flex-end" pt={3} pb={3}>
      <Pagination color="primary" disabled={loading} count={totalPageCount} page={currentPage} shape="rounded" onChange={handleChange} />
    </Box>
  );
};
